angular.module('impactx.basket').directive('ixBasketTemplateMenuItem', [function() {
    return {
        scope: {
            menuitem: "=",
            options: "="
        },
        controller: 'BasketTemplateMenuListCtrl',
        controllerAs: 'basketTemplateMenuListCtrl',
        restrict: 'E',
        templateUrl: 'modules/basket/templates/baskettemplatemenu.tmpl.html'
    }
}]);